import { render, staticRenderFns } from "./VoucherForm.vue?vue&type=template&id=ffd32654&scoped=true"
import script from "./VoucherForm.vue?vue&type=script&lang=js"
export * from "./VoucherForm.vue?vue&type=script&lang=js"
import style0 from "./VoucherForm.vue?vue&type=style&index=0&id=ffd32654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd32654",
  null
  
)

export default component.exports